import all from './all';
import store from './store';
import destroy from './destroy';

export default {
  all,
  store,
  destroy,
};



// WEBPACK FOOTER //
// ./src/app/services/businessHour/index.js